import React, { useLayoutEffect, useRef, useState } from "react";
import classNames from "classnames";
import { WEBSITE_BUILDER_Z_LAYERS } from "../../utility/websiteBuilderZLayers";
import "./websiteBuilderPanel.scss";

export const WEBSITE_BUILDER_PANEL_ID = "website-builder-panel";

/**
 * Persistent portal target for editor content. Render a Portal with
 * parentId={WEBSITE_BUILDER_PANEL_ID} to show content here while retaining
 * the caller's React context. The panel opens when content is mounted and
 * closes when it is removed; the content owns its close behavior.
 */
export function WebsiteBuilderPanel() {
  const panelRef = useRef<HTMLDivElement>(null);

  const [hasContent, setHasContent] = useState(false);

  useLayoutEffect(() => {
    const panel = panelRef.current;

    function updateHasContent() {
      setHasContent(panel.hasChildNodes());
    }

    const observer = new MutationObserver(updateHasContent);
    observer.observe(panel, { childList: true });

    updateHasContent();

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={panelRef}
      id={WEBSITE_BUILDER_PANEL_ID}
      className={classNames({ open: hasContent, closed: !hasContent })}
      onMouseOver={e => e.stopPropagation()}
      onMouseOut={e => e.stopPropagation()}
      onDoubleClick={e => e.stopPropagation()}
      onPointerDown={e => e.stopPropagation()}
      onContextMenu={e => {
        e.preventDefault();
        e.stopPropagation();
      }}
      style={{ zIndex: WEBSITE_BUILDER_Z_LAYERS.shell.ui }}
    />
  );
}
